<template>
    <div v-if="part" class="relative flex flex-col gap-2 md:min-h-72">
        <h3 class="font-title text-sm font-bold capitalize">{{ partTypeLabel }}</h3>
        <h4 class="line-clamp-2 leading-5.5 text-ellipsis">{{ part.name }}</h4>
        <div v-if="comment" class="text-sm">{{ comment }}</div>
        <div class="relative mt-auto aspect-square w-full bg-white">
            <img
                class="absolute h-full w-full object-contain p-3"
                :src="getImageUrl"
                :alt="$t('setup_card.part_image_alt', { name: part.name })"
            />
        </div>
        <div class="absolute right-0 bottom-0">
            <DiagonalCutButton variant="secondary" fillColor="bg-card" v-if="false">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-8 w-8"
                >
                    <path
                        d="M11.25 17.25V20H8.5V17.25H11.25ZM17.25 17.25V20H14.5V17.25H17.25ZM7.11914 4L7.96094 5.53809H21.7344L17.7041 12.5H10.7607L9.70996 14H19.1582V16H5.86816L9.05566 11.4492L6.50293 7.03906L6.49707 7.0293L6.49121 7.01855L5.93359 6H4V4H7.11914ZM10.8174 10.5H16.5508L18.2656 7.53809H9.10254L10.8174 10.5Z"
                        fill="#00D073"
                    />
                </svg>
            </DiagonalCutButton>
        </div>
    </div>
    <div v-else class="relative flex flex-col items-center justify-center gap-2 md:min-h-72">
        <div class="text-center text-gray-500">
            <svg
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mx-auto mb-2 opacity-30"
            >
                <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                    fill="currentColor"
                />
            </svg>
            <p class="text-xs">{{ $t('general.not_selected') }}</p>
        </div>
    </div>
</template>

<script>
import DiagonalCutButton from '../DiagonalCutButton.vue'

export default {
    name: 'SetupProduct',
    props: {
        part: {
            type: Object,
            required: false,
            default: null,
        },
        comment: {
            type: String,
            required: false,
            default: null,
        },
    },
    components: {
        DiagonalCutButton,
    },
    computed: {
        partTypeLabel() {
            const keys = {
                dart: 'setup_edit.dart_label',
                tip: 'setup_edit.point_label',
                barrel: 'setup_edit.barrel_label',
                shaft: 'setup_edit.shaft_label',
                flight: 'setup_edit.flight_label',
            }
            const type = this.part?.type
            return keys[type] ? this.$t(keys[type]) : type
        },
        getImageUrl() {
            if (!this.part || !this.part.image_url) return ''
            if (this.part.image_url.startsWith('http')) return this.part.image_url
            const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || ''
            const baseUrl = apiBaseUrl.replace(/\/api\/?$/, '')
            return `${baseUrl}/${this.part.image_url}`
        },
    },
}
</script>
